<template>
  <div class="modal is-active">
    <div
      class="modal-background"
      @click="close()"
    />

    <div
      :style="{
        height,
        maxWidth: width,
      }"
      class="modal-content"
    >
      <div
        v-if="$slots.title || hasCloseButton"
        class="modal-content__header"
      >
        <slot name="title" />
        <div
          v-if="hasCloseButton"
          class="close-button"
          @click="close()"
        >
          <i
            class="fas fa-times"
          />
        </div>
      </div>
      <div class="modal-content__body">
        <slot name="body" />
      </div>
      <div
        v-if="$slots.actions"
        class="modal-content__actions"
      >
        <slot name="actions" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BaseSimpleModal',
  props: {
    width: {
      default: '320px',
      type: String,
      required: true,
    },
    hasCloseButton: {
      default: false,
      type: Boolean,
      required: false,
    },
    hasEscape: {
      type: Boolean,
      default: true,
      required: false,
    },
    height: {
      type: String,
      required: false,
      default: '',
    },
  },
  created() {
    if (this.hasEscape) window.addEventListener('keydown', this.escape);
  },
  beforeDestroy() {
    if (this.hasEscape) window.removeEventListener('keydown', this.escape);
  },
  methods: {
    escape(event) {
      if (event.key === 'Escape') this.close();
    },
    close() {
      this.$emit('close');
    },
  },
};
</script>

<style lang="scss" scoped>
.button {
  padding: 9px, 17px;
  border-radius: 6px;

  font-weight: 500;

  &[disabled]{
    background-color: map.get($stone-types, "300");
    border: map.get($stone-types, "300");

    color: #FFF,
  }

  &.is-info {
    background-color: $blue-100;
    border: $blue-100;

    color: $blue-700;
  }

  &.is-success {
    &[disabled]{
      background-color: map.get($stone-types, "300");
      border: map.get($stone-types, "300");
    }

    background-color: $prata-green-600;
    color: #fff;
  }

  i {
    margin-left: 8px;
  }
}

.modal {
  padding: 1rem;
  height: 100% !important;
}

.modal-content {
  display: grid;
  width: 100%;
  padding: 16px;
  background-color: #FFF;
  border-radius: 8px;

  gap: 16px;

  &__header {
    position: relative;

    display: flex;
    min-height: 24px;

    font: {
      weight: 500;
      size: 18px;
    }
    color: map.get($stone-types, "900");
    line-height: 24px;

    justify-content: space-between;

    .close-button {
      position: absolute;
      top: 0;
      right: 0;

      color: map.get($stone-types, "400");
      font-size: 20px;

      &:hover {
        cursor: pointer;
      }
    }
  }

  &__body {
    display: flex;
    padding: .5rem 0;
    min-height: 80px;

    flex-direction: column;
    overflow-y: auto;
    overflow-x: hidden;
  }

  &__actions {
    display: flex;
    gap: 12px;
  }
}
</style>
